import React, { useState, useRef, useEffect } from "react";
import { FiPlus, FiCheck, FiX } from "react-icons/fi";

const NameInput = ({
  value,
  onChange,
  nickname,
  onNicknameChange,
  className = "",
}) => {
  const [showNicknameInput, setShowNicknameInput] = useState(false);
  const [tempNickname, setTempNickname] = useState(nickname || "");
  const nicknameInputRef = useRef(null);

  // Handle clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        nicknameInputRef.current &&
        !nicknameInputRef.current.contains(event.target)
      ) {
        setShowNicknameInput(false);
        setTempNickname(nickname || "");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [nickname]);

  const handleConfirm = () => {
    if (tempNickname.trim()) {
      onNicknameChange(tempNickname);
      setShowNicknameInput(false);
    }
  };

  const handleRemove = () => {
    onNicknameChange("");
    setShowNicknameInput(false);
    setTempNickname("");
  };

  return (
    <div className="relative">
      <div className="flex items-center">
        <input
          type="text"
          value={value}
          onChange={onChange}
          className={className}
        />
        <div className="absolute right-0 h-full flex items-center pr-2">
          {nickname && !showNicknameInput ? (
            <>
              <span className="text-sm text-gray-700 dark:text-gray-300 mr-2">
                prefers: {nickname}
              </span>
              <button
                type="button"
                onClick={handleRemove}
                className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-all"
                title="Remove preferred name"
              >
                <FiX className="w-4 h-4 text-gray-400 hover:text-red-600" />
              </button>
            </>
          ) : (
            !showNicknameInput && (
              <button
                type="button"
                onClick={() => setShowNicknameInput(true)}
                className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-all hover:scale-110"
                title="Add Preferred Name"
              >
                <FiPlus className="w-4 h-4 text-gray-400" />
              </button>
            )
          )}
        </div>
      </div>

      {/* Nickname input overlay */}
      {showNicknameInput && (
        <div
          ref={nicknameInputRef}
          className="absolute right-0 inset-y-0 flex items-center bg-surface-default dark:bg-surface-default border rounded-md shadow-sm"
        >
          <input
            type="text"
            value={tempNickname}
            onChange={(e) => setTempNickname(e.target.value)}
            placeholder="Enter preferred name"
            className="w-48 h-full px-3 border-none focus:ring-0 text-sm"
            autoFocus
          />
          <div className="flex border-l h-full">
            <button
              type="button"
              onClick={handleConfirm}
              className="h-full px-2 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors flex items-center"
              title="Confirm preferred name"
            >
              <FiCheck className="w-4 h-4 text-gray-400 hover:text-blue-600" />
            </button>
            <button
              type="button"
              onClick={handleRemove}
              className="h-full px-2 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors flex items-center"
              title="Remove preferred name"
            >
              <FiX className="w-4 h-4 text-gray-400 hover:text-red-600" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NameInput;
